import type { FC } from "react"

import { ModalBase } from "./ModalBase"
import UbiqButton, { UbiqButtonSize } from "./UbiqButton"

export const TicketLimitAlertModal: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  return (
    <ModalBase
      addBgOpacity
      dialogPanelStyles="px-8 py-10 w-full relative max-w-[320px]"
      onClose={onClose}
      show={isOpen}
    >
      <div className="text-[#232734] flex flex-col items-center justify-center text-[13px] text-center font-mono">
        <h1 className="text-[20px] leading-6 uppercase font-bold mb-4">Ticket alert</h1>
        <p className="mb-6 leading-[18px] text-[13px]">
          You've exceeded the maximum amount of tickets per member.
        </p>
        <UbiqButton onClick={onClose} size={UbiqButtonSize.MEDIUM} title="GOT IT" />
      </div>
    </ModalBase>
  )
}
